// This must be the first line in src/index.tsx
// tslint:disable-next-line: no-implicit-dependencies
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { Providers } from "./Providers";
import * as serviceWorker from "./serviceWorker";

const parentPath = window.parent.location.pathname;

const pathWhitelist = [
  "/home/change-login",
  "/home/change-password",
  "/home/confirm-login",
  "/home/create-document-password",
  "/home/change-document-password"
];
const isWhitelisted = pathWhitelist.some(whitelistedPath => parentPath.startsWith(whitelistedPath));

if (!parentPath.startsWith("/home") || isWhitelisted) {
  ReactDOM.render(<Providers />, document.getElementById("root"));
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
